/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertsReviewsService {
    /**
     * Fetch reviews for an expert (public)
     *
     * Returns paginated visible reviews for an expert profile.
     * No authentication required.
     *
     * **ID Format**: Accepts either:
     * - Display ID format: EX-01, EX-02, etc.
     * - UUID format: 550e8400-e29b-41d4-a716-446655440000
     *
     * **Response includes:**
     * - Aggregate stats (average rating, total reviews)
     * - Paginated review list with reviewer name, rating, text, and date
     *
     * @param id Expert ID (display format EX-XX or UUID)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns any Reviews fetched successfully
     * @throws ApiError
     */
    public static expertReviewsControllerGetExpertReviewsV1(
        id: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experts/{id}/reviews',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
}
